import { render, staticRenderFns } from "./TheMethod.vue?vue&type=template&id=0b9932b7&scoped=true&"
import script from "./TheMethod.vue?vue&type=script&lang=js&"
export * from "./TheMethod.vue?vue&type=script&lang=js&"
import style0 from "./TheMethod.vue?vue&type=style&index=0&id=0b9932b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9932b7",
  null
  
)

export default component.exports